export default __webpack_public_path__ + "static/media/ico_delete.cf883b13.svg";